// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"329":"5e388868","478":"5e388868","594":"5e388868"}[chunkId] + ".chunk.css";
};